import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import RetailPage from 'src/containers/Page/RetailPage';
import Button from 'src/components/Button/Button';
import './Cards.scss';
import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';

function Cards() {
  const [ticket, setTicket] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [success, setSuccess] = useState(false);
  const [ticketError, setTicketError] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const checkPinError = () => {
    return true;
  };

  const assignTicket = async () => {

    const assign = await dispatch.peripherals.assignTicket({ ticket, account: customerNumber });
    if (assign){
      setTicketError(false);
      setSuccess(true);
    } else {
      setTicketError(true);
      setSuccess(false);
    }
  };

  return (
    <RetailPage>
      <BreadCrumb breadcrumbs={ [{ name: t('retail.home'), link:'/' }, { name: t('home.cards'), link: ''  }] } />
      <div className="cards">
        <h2 className="cards__title">{ t('ticketDetails.linkCardToCustomer') }</h2>
        <form>
          <div className="cards__form">
            <h2 className="cards__form-title">{ t('ticketDetails.cardNumber') }</h2>
            <label className="cards__label">{ t('ticketDetails.number') }</label>
            <input
              type="text"
              autoComplete="new-password"
              className={
                classNames({
                  'cards__inputs' : true,
                  'cards__input--error': ticketError,
                  'cards__input--success': success
                })
              }
              onChange={ e => setTicket(e.target.value) }
            />
          </div>
          <div className="cards__form">
            <h2 className="cards__form-title">{ t('ticketDetails.customerAccountNumber') }</h2>
            <label className="cards__label">{ t('ticketDetails.number') }</label>
            <input
              type="text"
              autoComplete="new-password"
              className={
                classNames({
                  'cards__inputs' : true,
                  'cards__input--error': ticketError,
                  'cards__input--success': success
                })
              }
              onChange={ e => setCustomerNumber(e.target.value) }
            />
            { ticketError && <div className="cards__error">{ t('form.ticketError') }</div> }
            { success && <div className="cards__success">{ t('form.ticketSuccess') }</div> }

          </div>
          <div className="cards__buttons-container">
            <Button
              type="button"
              text={ t('retail.submit') }
              disabled={ !checkPinError() }
              className="btn btn--outlined cards__submit retail-home__button--revert-color"
              onClick={ assignTicket }
            />
          </div>
        </form>
      </div>
    </RetailPage>
  );
}

export default Cards;
